module.exports = new __parcel__URL__("guitar_select.c5e7d4f1.mp3").toString();